import React, { useRef, useState } from 'react'
import { Button, message, Modal, Spin } from 'antd'
import { useRequest } from '@sisyphe/hooks'
import * as api from 'services/user'
import { AddressProps } from './interface'
import Item from './Item'
import AddEdit from './AddEdit'
import './index.less'

export default function Address(props: AddressProps) {
  const [open, setOpen] = useState(false)
  const rowDataRef = useRef<SwaggerDTO.地址信息>()

  /**个人帐号信息-收获地址管理 */
  const {
    data: addressList,
    loading,
    run: queryUserAddressUsingPOST,
  } = useRequest(async () => {
    const { data } = await api.queryUserAddressUsingPOST()
    data.sort((a, b) => b.defaultAddressTag - a.defaultAddressTag)
    return data
  })

  /**设为默认地址 */
  const { loading: setLoading, run: addressDefaultUsingPOST } = useRequest(
    async ({ id }) => {
      await api.addressDefaultUsingPOST(id)
      message.success('操作成功')
      queryUserAddressUsingPOST()
    },
    { manual: true }
  )

  /**用户地址删除 */
  const { loading: delLoading, run: addressDelUsingPOST } = useRequest(
    async id => {
      await api.addressDelUsingPOST(id)
      message.success('操作成功')
      queryUserAddressUsingPOST()
    },
    { manual: true }
  )

  // 编辑
  const editHandle = row => {
    rowDataRef.current = row
    setOpen(true)
  }

  // 删除
  const deleteHandle = row => {
    Modal.confirm({
      title: '提示',
      content: '确定要删除该收货地址吗？',
      onOk() {
        addressDelUsingPOST(row.id)
      },
    })
  }

  return (
    <Spin spinning={loading || setLoading || delLoading}>
      <div className="id-address">
        <div className="address-add">
          <Button
            className="address-add-btn"
            type="primary"
            onClick={() => {
              setOpen(true)
              rowDataRef.current = undefined
            }}
          >
            新增收货地址
          </Button>
          <span className="address-add-tips">
            您已创建{addressList?.length}个收货地址，最多可创建10个
          </span>
        </div>
        <div className="address-list">
          {addressList?.map(item => (
            <Item
              key={item.id}
              data={item}
              editHandle={editHandle}
              defaultHandle={addressDefaultUsingPOST}
              deleteHandle={deleteHandle}
            />
          ))}
        </div>
        <Modal
          title={rowDataRef.current ? '编辑收货地址' : '新增收货地址'}
          open={open}
          width={500}
          onCancel={() => setOpen(false)}
          maskClosable={false}
          footer={false}
          keyboard={false}
          destroyOnClose
        >
          <AddEdit
            onCancel={() => setOpen(false)}
            onOk={queryUserAddressUsingPOST}
            data={rowDataRef.current}
          />
        </Modal>
      </div>
    </Spin>
  )
}
